import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import Avatar from '../../../../../avatar/Avatar'
import AvatarSkeleton from '../../../../../avatar/AvatarSkeleton'
import Skeleton from '@mui/material/Skeleton'

const UserInfo = ({ user, size = 'dashboard', variant = 'rounded', loading }) => {

  return (
    <div className='flex items-center justify-center gap-2'>
      { loading 
        ? <AvatarSkeleton size={size} variant={variant} />
        : <Avatar
          size={size}
          variant={variant}
          alt={user?.code}
          src={`photos/${user?.photo || `${user.userId}.jpg`} `}
        /> 
      }
      <div>
        <Typography variant='subtitle1' color='primary'>
          {loading ? <Skeleton width={50} /> : user?.code}
        </Typography>
        <Typography variant='body2'>
          {loading ? <Skeleton width={120} /> : user?.fullName}
        </Typography>
        <div className='flex flex-wrap items-center gap-2'>
          { loading 
            ? <Skeleton width={50} /> 
            : user?.roles?.map((role) => (
              <Chip
                key={`form-log-role-${role._id}`}
                size='small'
                label={role.name}
              />
            ))
          } 
        </div>
      </div>
    </div>
  )
}

export default UserInfo